import { buildTokenRequestConfig } from './BusTokenRequestConfig';
import { BusTokenError, createBusTokenManager } from './BusTokenManager';

type ValidateDestination = (url: string, expectedBase: string) => string;
let identity = '';
let manager: ReturnType<typeof createBusTokenManager> | undefined;

/** Configuration identity is private and never logged; changing scope/credentials drops the cache. */
export function configuredBusTokens(validate: ValidateDestination) {
  const base = process.env.VUE_APP_API_URL_TOYOTA_BUS_TOKEN;
  if (!base) throw new BusTokenError();
  const raw = base.replace(/\/$/, '');
  const url = raw.endsWith('/OAuth2Token') ? raw : raw + '/OAuth2Token';
  const parsed = new URL(url);
  if (parsed.protocol !== 'https:' || parsed.username || parsed.password) throw new BusTokenError();
  const trusted = validate(url, base);
  const { params, headers } = buildTokenRequestConfig();
  const key = JSON.stringify([trusted, params.toString(), Array.from(headers.entries())]);
  if (!manager || identity !== key) {
    identity = key;
    manager = createBusTokenManager(async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(trusted, {
          method: 'POST', body: params, headers,
          redirect: 'error', signal: controller.signal,
        });
        if (!response.ok) {
          throw new BusTokenError(response.status === 401 || response.status === 408 ||
            response.status === 429 || response.status >= 500);
        }
        try { return await response.json(); }
        catch (_) { throw new BusTokenError(true); }
      } catch (error) {
        if (error instanceof BusTokenError) throw error;
        throw new BusTokenError(true);
      } finally { clearTimeout(timeout); }
    });
  }
  return manager;
}
